import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-generic-status-icon',
  templateUrl: './generic-status-icon.component.html',
  styleUrls: ['./generic-status-icon.component.scss']
})
export class GenericStatusIconComponent implements OnInit {
    @Input() state = 'ok';
  constructor() { }

  ngOnInit(): void {
  }

}
